import React, { memo } from 'react'

import { useUnit } from 'effector-react'

import { useMediaQueries } from 'hooks'

import { $features } from 'app/effector/features'

import { Typo } from 'components/_old/Typo'

import { Typography } from 'components/atoms/Typography'

const Title = memo(() => {
  const { desktop } = useMediaQueries()
  const features = useUnit($features)

  return (
    <Typography size={desktop ? 24 : 18} weight="semibold" lineHeight="small">
      <Typo>
        {features.get('multiple-sipp-providers-transfer') ? 'Existing pension provider' : 'Transfer from Vanguard'}
      </Typo>
    </Typography>
  )
})
Title.displayName = 'Title'

export { Title }
